export enum AdminRole {
  SUPER_ADMIN = "super_admin",
  ADMIN = "admin",
}
